import Vue from 'vue'
import 'codemirror/lib/codemirror.css'
import '@toast-ui/editor/dist/toastui-editor.css'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import '@toast-ui/editor/dist/i18n/ko-kr'
// import 'highlight.js/styles/github.css'

// import hljs from 'highlight.js'
import { Editor, Viewer } from '@toast-ui/vue-editor'
// import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight'

// eslint-disable-next-line new-cap
// const editor = new Editor.editor({
//   // ...
//   // plugins: [[codeSyntaxHighlight, { hljs }]]
// })

Vue.component('editor', Editor)
Vue.component('viewer', Viewer)
